export default "__VITE_ASSET__QypQwjI___"